import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import Modal from '../../../Modal';
import Form, { FormBody, FormActions, TextInput, SwitchInput } from '../../../Form';
import ReactDropzone from 'react-dropzone';

@inject('reportingTemplateHeaderStore')
@observer
class ReportingHeaderModify extends Component {
  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  }

  @observable editMode = false;

  @observable item = {
    title1: '',
    title2: '',
    logo: '',
    default: false,
  };

  slug = '/export/report/header';
  title = '';

  componentWillMount() {
    const { params: { id } } = this.props;

    this.editMode = id !== 'add';
    if (this.editMode) {
      this.title = 'Edit Reporting Template Header';
      this.reset();
    } else this.title = 'Add Reporting Template Header';
  }

  @action reset = () => {
    const { params: { id }, reportingTemplateHeaderStore } = this.props;
    const foundUnit = reportingTemplateHeaderStore.findById(id);
    if (foundUnit) {
      this.item = foundUnit.asJson;
    }
  }

  @action onChange = (e, field) => this.item[field] = e.target.value;

  handleSave = (e) => {
    e.preventDefault();

    const { reportingTemplateHeaderStore } = this.props;
    const { notify, router } = this.context;

    const existingDefault = reportingTemplateHeaderStore.items.find(item => item.default);

    (this.editMode ? reportingTemplateHeaderStore.updateItem(this.item) : reportingTemplateHeaderStore.createItem(this.item))
      .then(() => {
        if (this.item.default && existingDefault) {
          reportingTemplateHeaderStore.items.find(item => item.id === existingDefault.id).default = false;
        }
        notify.success({ message: 'Success' });
        router.push(this.slug);
      })
      .catch(err => {
        console.log(err);
        notify.error(err);
      });
  }

  addLogo = (files) => {
    const fileType = files[0].type;
    if (!fileType.includes('image')) {
      this.context.notify.error({ message: 'Invalid file type.' });
      return;
    }
    let reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onabort = console.log;
    reader.onload = () => {
      const base64 = reader.result;
      this.item.logo = base64;
    }
  }

  render() {
    const { reportingTemplateHeaderStore } = this.props;

    return (
      <Modal title={this.title} slug={this.slug} isLoading={reportingTemplateHeaderStore.isLoading} isSaving={reportingTemplateHeaderStore.isSaving} handleSave={this.handleSave}>
        <Form>
          <div className='flex'>
            <FormBody>
              <TextInput label={'Title 1'} value={this.item.title1} onChange={e => this.item.title1 = e.target.value} />
              <TextInput label={'Title 2'} value={this.item.title2} onChange={e => this.item.title2 = e.target.value} />
              <SwitchInput label={'Default'} value={this.item.default} onChange={e => this.item.default = e.target.checked} />
            </FormBody>
            <div>
              {this.item.logo && <img src={this.item.logo} style={{ width: '100px', height: '100px' }} alt='logo' />}
              <ReactDropzone ref="dropzone-logo" onDrop={this.addLogo} style={{ display: 'block' }}>
                <p className="button">{this.item.logo ? 'Edit' : 'Add'} Logo</p>
              </ReactDropzone>
            </div>
          </div>
          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default ReportingHeaderModify;



// WEBPACK FOOTER //
// ./src/components/DataDelivery/ReportingTemplate/ReportingHeader/ReportingHeaderModify.js